import {
  applyLeave,
  getLeaveDetails,
  getLeaveStatusDetails,
  getLeaveStatus,
  approveLeave,
  rejectLeave,
  createLeaveMaster,
  getLeaveMasterDetails
} from './api'

import { manageLeaveSlice } from './reducer'

const { resetSelectedLeave, resetLeaveDetails } = manageLeaveSlice.actions

export {
  applyLeave,
  getLeaveDetails,
  getLeaveStatusDetails,
  getLeaveStatus,
  resetSelectedLeave,
  resetLeaveDetails,
  approveLeave,
  rejectLeave,
  createLeaveMaster,
  getLeaveMasterDetails
}
